<script lang="ts">
import Layout from "@/Layouts/AppBase.vue";
import AcpNavigation from "@/Components/ACP/AcpNavigation.vue";
import { defineComponent } from "vue";

export default defineComponent({
    components: {
        Layout,
        AcpNavigation,
    },
});
</script>

<template>
    <Layout>
        <template #navigation>
            <AcpNavigation />
        </template>
        <template #content>
            <slot></slot>
        </template>
    </Layout>
</template>
